export default "__VITE_ASSET__HQx71X_u__"